const resubscribeTypes = {
  resub3month: 'resub3month',
  resub5month: 'resub5month',
  resub25: 'resub25',
  resub50: 'resub50',
  resubfree: 'resubfree',
  resubcard: 'resubcard',
  resubnew: 'resubnew', // $5 off
  resub10reason: 'resub10reason',
  resub5month12: 'resub5month12',
  resubfreecase: 'resubfreecase',
  resub5month1350: 'resub5month1350',
  resubfreeproduct: 'resubfreeproduct',
} as const

export type ResubscribeType = typeof resubscribeTypes[keyof typeof resubscribeTypes]


export default resubscribeTypes
